import Utils from '../../modules/utils'

const deleteNote = (noteId, callbackFunc) => {
  const url = 'delete_vpo_notes'
  const data = {noteId}
  Utils.post(url, data, callbackFunc)
}

export {deleteNote}
